var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvChargingAlt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 121 121",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-861,-150)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04913,0,0,1.86899,199.71,-1682.46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "evAlt",
    transform: "matrix(1,0,0,1,-17.417,11.0014)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.806248,0,0,0.452573,461.452,370.482)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 302.383,
    cy: 1395.21,
    r: 70.807,
    style: {
      fill: "rgb(0,177,92)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0391899,0,0,0.0219986,652.237,978.203)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(19.0993,0,0,19.0993,-13105.1,-7226.51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M759.422,400.002L716.797,399.963C711.954,399.991 710.497,401.125 710.552,405.72L710.487,444.743C710.469,455.492 714.799,454.713 723.841,454.728",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "5.09px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer4",
    transform: "matrix(19.0993,0,0,19.0993,-13063.5,-7991.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M720.679,488.626L720.682,504.601L725.877,511.403L732.076,511.403C732.828,507.125 734.846,504.113 739.649,503.888C743.354,504.226 746.067,506.383 747.222,511.403L773.93,511.403C773.951,505.823 777.485,503.873 781.503,503.888C786.035,503.386 788.58,505.455 789.21,511.143C793.858,511.254 798.393,509.761 800.284,509.114C802.926,507.981 806.033,505.188 806.116,500.431C806.116,491.329 799.557,488.856 792.381,488.346C777.92,487.318 720.679,488.626 720.679,488.626Z",
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "2.55px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(14.5126,0,0,13.8916,-9493.37,-4757.14)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 782.495,
    cy: 470.456,
    rx: 9.966,
    ry: 10.332,
    style: {
      fill: "rgb(0,177,92)",
      stroke: "white",
      strokeWidth: "6.85px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(14.5126,0,0,13.8916,-10292.7,-4757.14)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 782.495,
    cy: 470.456,
    rx: 9.966,
    ry: 10.332,
    style: {
      fill: "rgb(0,177,92)",
      stroke: "white",
      strokeWidth: "6.85px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(16.7924,0,0,15.4589,-11310.7,-5556.01)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M751.616,448.308L718.939,448.308L718.939,435.853C718.908,433.881 719.855,430.873 721.587,429.607C723.813,427.978 727.244,428.356 730.595,428.3C730.595,428.3 741.997,428.258 751.086,428.3L751.616,448.308Z",
    style: {
      fill: "rgb(0,177,92)",
      stroke: "white",
      strokeWidth: "6.03px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(19.671,0,0,20.4101,-13499.7,-7751.83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M788.222,446.953L752.697,447.122L752.239,431.967C752.239,431.967 762.395,432.014 771.484,432.056L788.222,446.953Z",
    style: {
      fill: "rgb(0,177,92)",
      stroke: "white",
      strokeWidth: "4.85px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.87236,0.00265985,0.00284974,3.30257,203.601,-511.278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M833.723,312.59L922.626,312.408",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "18.1px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.89828,0.00201136,0.00215496,3.30258,182.208,-731.666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M833.723,312.59L921.412,312.451",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "18.05px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.10755,0,0,2.33903,7.33108,-179.47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M664.332,256.301C664.813,184.261 728.853,164.091 831.748,162.735L834.236,351.489C724.41,350.755 663.839,330.095 664.332,256.301Z",
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "21.85px"
    }
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvChargingAlt);
export default __webpack_public_path__ + "static/media/evChargingAlt.838d5237ef89aeb4dd21697529044ee2.svg";
export { ForwardRef as ReactComponent };